import { defineStore } from 'pinia'

export const useLoader = defineStore('loader', {
  state: () => ({
    counter: 0,
  }),

  getters: {
    loading: state => state.counter !== 0,
  },

  actions: {
    increment() {
      this.counter++
    },
    decrement() {
      if (this.counter === 0) return

      this.counter--
    },
  },
})

declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $loader: {
      loading: boolean
      increment(): void
      decrement(): void
    }
  }
}
